import { render, staticRenderFns } from "./DashboardKpisEx.vue?vue&type=template&id=e7932998&shadow"
import script from "./DashboardKpisEx.vue?vue&type=script&lang=js&shadow"
export * from "./DashboardKpisEx.vue?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports